import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaShieldAlt, FaTerminal } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navItems = [
    { name: 'Home', path: '/', icon: '~/' },
    { name: 'Portfolio', path: '/portfolio', icon: './portfolio' },
    { name: 'Blog', path: '/blog', icon: './blog' },
    { name: 'Contact', path: '/contact', icon: './contact' },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrolled
        ? 'bg-cyber-dark/95 backdrop-blur-md border-b border-cyber-green/20 shadow-lg shadow-cyber-green/5'
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <NavLink to="/" className="flex items-center gap-2 group">
            <div className="relative">
              <FaShieldAlt className="text-cyber-green text-2xl group-hover:text-cyber-cyan transition-colors" />
              <div className="absolute inset-0 bg-cyber-green/20 rounded-full blur-md opacity-0 group-hover:opacity-100 transition-opacity"></div>
            </div>
            <div className="flex items-center">
              <FaTerminal className="text-cyber-green text-xs mr-1" />
              <span className="text-cyber-green font-bold text-lg tracking-wide">
                ARAP<span className="text-cyber-cyan">BETT</span>
              </span>
            </div>
          </NavLink>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `relative px-4 py-2 text-sm font-mono transition-all duration-200 rounded ${
                    isActive
                      ? 'text-cyber-green bg-cyber-green/10 border border-cyber-green/30'
                      : 'text-cyber-muted hover:text-cyber-green hover:bg-cyber-green/5'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span className="text-cyber-green/50 mr-1">$</span>
                    {item.name.toLowerCase()}
                    {isActive && (
                      <span className="absolute -bottom-px left-1/2 -translate-x-1/2 w-3/4 h-px bg-cyber-green shadow-sm shadow-cyber-green"></span>
                    )}
                  </>
                )}
              </NavLink>
            ))}
            <div className="ml-3 pl-3 border-l border-cyber-green/20">
              <span className="text-xs text-cyber-muted font-mono animate-pulse-glow">
                <span className="text-cyber-green">●</span> ONLINE
              </span>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-cyber-green hover:text-cyber-cyan transition-colors p-2"
          >
            {isOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mobile-menu-enter pb-4 border-t border-cyber-green/20 mt-2">
            <div className="pt-3 space-y-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.path}
                  className={({ isActive }) =>
                    `block px-4 py-3 text-sm font-mono rounded transition-all ${
                      isActive
                        ? 'text-cyber-green bg-cyber-green/10 border-l-2 border-cyber-green'
                        : 'text-cyber-muted hover:text-cyber-green hover:bg-cyber-green/5'
                    }`
                  }
                >
                  <span className="text-cyber-green/50 mr-2">{'>'}</span>
                  {item.icon}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
